<template>
    <v-list subheader>
        <v-subheader class="font-weight-bold">{{$translate('Choose number of columns for new row')}}</v-subheader>
        <v-list-item v-for="option in options" :key="option.id" @click="add(option)" link>
            <v-hover v-slot:default="{ hover }">
                <v-list-item-content style="width: 256px; cursor: pointer">
                    <v-row no-gutters style="height: 40px">
                        <v-col v-for="(col,colindex) in option.data" :key="colindex" :md="col.width">
                            <v-sheet :color="hover ? 'zoezi-edit-color' : 'rgb(210,210,210)'" class="fill-height mx-2" />
                        </v-col>
                    </v-row>
                </v-list-item-content>
            </v-hover>
        </v-list-item>
    </v-list>
</template>

<script>
import components from '../component.js'
export default {
    name: 'ColumnsMenu',
    data: () => ({
        options: [
            {id: 1, data: [{width: 12}] },
            {id: 2, data: [{width: 6},{width: 6}] },
            {id: 3, data: [{width: 4},{width: 4},{width: 4}] },
            {id: 4, data: [{width: 8},{width: 4}] },
            {id: 5, data: [{width: 4},{width: 8}] }
        ]
    }),

    methods: {
        add(option) {
            let columns = option.data.map(col => components.makeEmptyConfig({component: 'zoezi-column', props: {cols: col.width, component: components.makeEmptyConfig()}}));
            let row = components.makeEmptyConfig({component: 'zoezi-row', props: {columns}});
            this.$emit('add', row);
        }
    }
}
</script>
